import moment from 'moment-timezone';
import { Component } from 'react';

type PrinterFriendlyProps = {
  originalEmail: any;
  htmlIframeSrc: string | null;
};

class PrinterFriendly extends Component<PrinterFriendlyProps> {
  render() {
    const { currentOriginalEmail } = this.props.originalEmail;
    // `contactform` resources does not seem to have `msg` object
    // and have everything in root.
    const msg = currentOriginalEmail?.msg || currentOriginalEmail;
    if (!msg) {
      return null;
    }

    const to = Array.isArray(msg.to)
      ? msg.to.map((t: Array<string>) => `${t.join(', ')}\n`)
      : '';
    const subject = msg.subject;
    const fromName = msg.from_name;
    const fromEmail = msg.from_email;
    const date = msg.headers?.Date;
    const humanDate = date ? moment(date).local().format('LLLL') : '';

    return (
      <div>
        <iframe
          className="hidden"
          srcDoc={`
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tbody>
                  <tr>
                    <td colspan="2" style="font-size: small;color: #777;text-align:right">
                      <b>${fromName} ${fromEmail}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <hr />
                      <font size="+1"><b>${subject}</b></font><br>
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: small;">
                      ${to}
                    </td>
                    <td style="text-align:right">
                      ${humanDate}
                    </td>
                  </tr>
                </tbody>
              </table>
              ${this.props.htmlIframeSrc}
              `}
          style={{ border: '0', width: '100%', height: '100vh' }}
          id="printer-friendly"
        />
      </div>
    );
  }
}

export default PrinterFriendly;
